// User Store Module

const state = {
	usrName: "Steve is Great!",
	count: 123,
};

const getters = {
	state: state => {return state}, // this whole namepaced state
}

const mutations = {
	increment: (state, qty) => {
		state.count += qty;
	},
}

const actions = {
	incrementCount: ({ commit }, qty) => {
		commit('increment', qty);
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}